import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-card-with-tabs-boxer.js';
const html = `
<div class="container">
  <div class="wrap-card">
    <div data-attribute="title-card" data-show="true" class="card-title">
      <h2 style="text-align:center;">What Men Say After Switching</h2>
      <p style="text-align:center;">Thousands of men have already made the switch. Here's what they noticed after
        wearing them for the first time.</p>
    </div>
    <div class="wrap-content">
      <div data-color-tab-nav="#000000" data-active-color-tab-nav="#ffffff" data-active-background-tab-nav="#606F99"
        data-background-tab-nav="#ffffff" data-border-radius-tab-nav="5" data-attribute="list-tab-nav"
        class="list-tab-nav"
        style="--color-tab-nav: #000000; --background-tab-nav: #ffffff; --border-radius-tab-nav: 5px; --active-color-tab-nav: #ffffff; --active-background-tab-nav: #606F99;">
        <div data-tab="tab-1" data-attribute="tab-nav-item" class="tab-nav-item active">SWEAT</div>
        <div data-tab="tab-2" data-attribute="tab-nav-item" class="tab-nav-item">ORDER</div>
        <div data-tab="tab-3" data-attribute="tab-nav-item" class="tab-nav-item">LEAK-PROOF</div>
        <div data-tab="tab-4" data-attribute="tab-nav-item" class="tab-nav-item">ITCH OR CHAFE</div>
      </div>

      <div data-attribute="list-tab-content" data-color-item="#ffffff" data-col-per-view="3" data-space-between="30"
        data-border-radius="0" data-background="#3c3c3c" data-border="#eff3fa" class="list-tab-content"
        style="--color-item: #ffffff; --col-per-view: 3; --space-between: 30px; --border-radius: 0px; --border: #eff3fa; --background: #3c3c3c;">
        <div data-tab="tab-1" data-attribute="tab-content" class="tab-content active">
          <div class="wrap-child-item">
            <div data-attribute="child-item" class="child-item">
              <div data-attribute="review" class="review">
                <p style="text-align:center;"><span style="font-size:14px;"><span
                      style="-webkit-text-stroke-width:0px;display:inline !important;float:none;font-family:&quot;Mona Sans&quot;, sans-serif;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:center;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">"I
                      wore these on a hot Florida day and they stayed surprisingly dry. My regular boxers would've been
                      soaked by noon."</span></span></p>
              </div>
              <div class="wrap-user-info">
                <div data-attribute="avatar" class="avatar">
                  <img src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fb69dbb9aa5dc9699066.png" alt="">
                </div>
                <div data-attribute="username" class="username">John Doe</div>
                <div data-attribute="verified" data-show="true" class="verified" style="display: flex;;">
                  <img data-attribute="verified-icon"
                    src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fcd8aa1322ed152c7741.png" alt="">
                  <span data-attribute="verified-text">Verified Buyer</span>
                </div>
              </div>
            </div>

            <div data-attribute="child-item" class="child-item">
              <div data-attribute="review" class="review">
                <p style="text-align:center;"><span style="font-size:14px;"><span
                      style="-webkit-text-stroke-width:0px;display:inline !important;float:none;font-family:&quot;Mona Sans&quot;, sans-serif;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:center;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">"Finally,
                      underwear that handles sweat. Even after a long day at work, they still felt breathable and
                      comfortable."</span></span></p>
              </div>
              <div class="wrap-user-info">
                <div data-attribute="avatar" class="avatar">
                  <img src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fb6d799a8cef9bdd7586.png" alt="">
                </div>
                <div data-attribute="username" class="username">Brian T.</div>
                <div data-attribute="verified" data-show="true" class="verified" style="display: flex;;">
                  <img data-attribute="verified-icon"
                    src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fcd8aa1322ed152c7741.png" alt="">
                  <span data-attribute="verified-text">Verified Buyer</span>
                </div>
              </div>
            </div>

            <div data-attribute="child-item" class="child-item">
              <div data-attribute="review" class="review">
                <p style="text-align:center;"><span style="font-size:14px;"><span
                      style="-webkit-text-stroke-width:0px;display:inline !important;float:none;font-family:&quot;Mona Sans&quot;, sans-serif;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:center;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">"I
                      hike a lot and sweat easily. These kept things cool and dry the entire trip."</span></span></p>
              </div>
              <div class="wrap-user-info">
                <div data-attribute="avatar" class="avatar">
                  <img src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fb70c795b46b3107220b.png" alt="">
                </div>
                <div data-attribute="username" class="username">Jason R.</div>
                <div data-attribute="verified" data-show="true" class="verified" style="display: flex;;">
                  <img data-attribute="verified-icon"
                    src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fcd8aa1322ed152c7741.png" alt="">
                  <span data-attribute="verified-text">Verified Buyer</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div data-tab="tab-2" data-attribute="tab-content" class="tab-content">
          <div class="wrap-child-item">
            <div data-attribute="child-item" class="child-item">
              <div data-attribute="review" class="review">
                <p style="text-align:center;"><span style="font-size:14px;"><span
                      style="-webkit-text-stroke-width:0px;display:inline !important;float:none;font-family:&quot;Mona Sans&quot;, sans-serif;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:center;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">"I
                      wore these on a hot Florida day and they stayed surprisingly dry. My regular boxers would've been
                      soaked by noon."</span></span></p>
              </div>
              <div class="wrap-user-info">
                <div data-attribute="avatar" class="avatar">
                  <img src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fb74f5518d914ced952c.png" alt="">
                </div>
                <div data-attribute="username" class="username">Kevin S.</div>
                <div data-attribute="verified" data-show="true" class="verified" style="display: flex;;">
                  <img data-attribute="verified-icon"
                    src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fcd8aa1322ed152c7741.png" alt="">
                  <span data-attribute="verified-text">Verified Buyer</span>
                </div>
              </div>
            </div>

            <div data-attribute="child-item" class="child-item">
              <div data-attribute="review" class="review">
                <p style="text-align:center;"><span style="font-size:14px;"><span
                      style="-webkit-text-stroke-width:0px;display:inline !important;float:none;font-family:&quot;Mona Sans&quot;, sans-serif;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:center;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">“The
                      bamboo fabric really helps keep things fresh.”</span></span></p>
              </div>
              <div class="wrap-user-info">
                <div data-attribute="avatar" class="avatar">
                  <img src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fb793c1516dcf503a75d.png" alt="">
                </div>
                <div data-attribute="username" class="username">Michael B.</div>
                <div data-attribute="verified" data-show="true" class="verified" style="display: flex;;">
                  <img data-attribute="verified-icon"
                    src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fcd8aa1322ed152c7741.png" alt="">
                  <span data-attribute="verified-text">Verified Buyer</span>
                </div>
              </div>
            </div>

            <div data-attribute="child-item" class="child-item">
              <div data-attribute="review" class="review">
                <p style="text-align:center;"><span style="font-size:14px;"><span
                      style="-webkit-text-stroke-width:0px;display:inline !important;float:none;font-family:&quot;Mona Sans&quot;, sans-serif;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:center;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">“After
                      trying these, I replaced all my old boxers.”</span></span></p>
              </div>
              <div class="wrap-user-info">
                <div data-attribute="avatar" class="avatar">
                  <img src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fb7eaac7f82b657795d5.png" alt="">
                </div>
                <div data-attribute="username" class="username">Eric G.</div>
                <div data-attribute="verified" data-show="true" class="verified" style="display: flex;;">
                  <img data-attribute="verified-icon"
                    src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fcd8aa1322ed152c7741.png" alt="">
                  <span data-attribute="verified-text">Verified Buyer</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div data-tab="tab-3" data-attribute="tab-content" class="tab-content">
          <div class="wrap-child-item">
            <div data-attribute="child-item" class="child-item">
              <div data-attribute="review" class="review">
                <p style="text-align:center;"><span style="font-size:14px;"><span
                      style="-webkit-text-stroke-width:0px;display:inline !important;float:none;font-family:&quot;Mona Sans&quot;, sans-serif;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:center;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">"These
                      give me peace of mind without feeling bulky."</span></span></p>
              </div>
              <div class="wrap-user-info">
                <div data-attribute="avatar" class="avatar">
                  <img src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fb8099944ad89288525d.png" alt="">
                </div>
                <div data-attribute="username" class="username">George M.</div>
                <div data-attribute="verified" data-show="true" class="verified" style="display: flex;;">
                  <img data-attribute="verified-icon"
                    src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fcd8aa1322ed152c7741.png" alt="">
                  <span data-attribute="verified-text">Verified Buyer</span>
                </div>
              </div>
            </div>

            <div data-attribute="child-item" class="child-item">
              <div data-attribute="review" class="review">
                <p style="text-align:center;"><span style="font-size:14px;"><span
                      style="-webkit-text-stroke-width:0px;display:inline !important;float:none;font-family:&quot;Mona Sans&quot;, sans-serif;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:center;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">"They
                      look like normal boxers but offer real protection."</span></span></p>
              </div>
              <div class="wrap-user-info">
                <div data-attribute="avatar" class="avatar">
                  <img src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fb83e56afd85e8ec026b.png" alt="">
                </div>
                <div data-attribute="username" class="username">Walter B.</div>
                <div data-attribute="verified" data-show="true" class="verified" style="display: flex;;">
                  <img data-attribute="verified-icon"
                    src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fcd8aa1322ed152c7741.png" alt="">
                  <span data-attribute="verified-text">Verified Buyer</span>
                </div>
              </div>
            </div>

            <div data-attribute="child-item" class="child-item">
              <div data-attribute="review" class="review">
                <p style="text-align:center;"><span style="font-size:14px;"><span
                      style="-webkit-text-stroke-width:0px;display:inline !important;float:none;font-family:&quot;Mona Sans&quot;, sans-serif;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:center;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">"Great
                      backup protection during long days."</span></span></p>
              </div>
              <div class="wrap-user-info">
                <div data-attribute="avatar" class="avatar">
                  <img src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fb8750dfba90dc8d9c5c.png" alt="">
                </div>
                <div data-attribute="username" class="username">Henry C.</div>
                <div data-attribute="verified" data-show="true" class="verified" style="display: flex;;">
                  <img data-attribute="verified-icon"
                    src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fcd8aa1322ed152c7741.png" alt="">
                  <span data-attribute="verified-text">Verified Buyer</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div data-tab="tab-4" data-attribute="tab-content" class="tab-content">
          <div class="wrap-child-item">
            <div data-attribute="child-item" class="child-item">
              <div data-attribute="review" class="review">
                <p style="text-align:center;"><span style="font-size:14px;"><span
                      style="-webkit-text-stroke-width:0px;display:inline !important;float:none;font-family:&quot;Mona Sans&quot;, sans-serif;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:center;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">"No
                      more thigh chafing during long walks."</span></span></p>
              </div>
              <div class="wrap-user-info">
                <div data-attribute="avatar" class="avatar">
                  <img src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fb8b346e82e384c96f7d.png" alt="">
                </div>
                <div data-attribute="username" class="username">Luke D.</div>
                <div data-attribute="verified" data-show="true" class="verified" style="display: flex;;">
                  <img data-attribute="verified-icon"
                    src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fcd8aa1322ed152c7741.png" alt="">
                  <span data-attribute="verified-text">Verified Buyer</span>
                </div>
              </div>
            </div>

            <div data-attribute="child-item" class="child-item">
              <div data-attribute="review" class="review">
                <p style="text-align:center;"><span style="font-size:14px;"><span
                      style="-webkit-text-stroke-width:0px;display:inline !important;float:none;font-family:&quot;Mona Sans&quot;, sans-serif;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:center;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">"The
                      fabric is soft and doesn't irritate my skin."</span></span></p>
              </div>
              <div class="wrap-user-info">
                <div data-attribute="avatar" class="avatar">
                  <img src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fb9015ab95980c49e161.png" alt="">
                </div>
                <div data-attribute="username" class="username">Nathan R.</div>
                <div data-attribute="verified" data-show="true" class="verified" style="display: flex;;">
                  <img data-attribute="verified-icon"
                    src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fcd8aa1322ed152c7741.png" alt="">
                  <span data-attribute="verified-text">Verified Buyer</span>
                </div>
              </div>
            </div>

            <div data-attribute="child-item" class="child-item">
              <div data-attribute="review" class="review">
                <p style="text-align:center;"><span style="font-size:14px;"><span
                      style="-webkit-text-stroke-width:0px;display:inline !important;float:none;font-family:&quot;Mona Sans&quot;, sans-serif;font-style:normal;font-variant-caps:normal;font-variant-ligatures:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:center;text-decoration-color:initial;text-decoration-style:initial;text-decoration-thickness:initial;text-indent:0px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;">"My
                      skin is sensitive and these don't itch."</span></span></p>
              </div>
              <div class="wrap-user-info">
                <div data-attribute="avatar" class="avatar">
                  <img src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fb94feb1320d0b0fed27.png" alt="">
                </div>
                <div data-attribute="username" class="username">Connor H.</div>
                <div data-attribute="verified" data-show="false" class="verified" style="display: none;;">
                  <img data-attribute="verified-icon"
                    src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fcd8aa1322ed152c7741.png" alt="">
                  <span data-attribute="verified-text">Verified Buyer</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;

export default containerFuild(html, css, {
  backgroundImage: 'https://www.titanboxers.com/images/bg-1.webp',
  overlayColor: '#000000',
  overlayOpacity: 0.5,
  showOverlay: true,
  textColor: '#ffffff',
});
